import * as server from '../entries/pages/dokumenty/_page.server.ts.js';

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/dokumenty/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/dokumenty/+page.server.ts";
export const imports = ["_app/immutable/nodes/7.BTtaJ_P-.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/DwKR0wUy.js","_app/immutable/chunks/DmC62j6_.js"];
export const stylesheets = [];
export const fonts = [];
